import styled from "styled-components"
import {
  WHITE_COLOR,
  ORANGE_COLOR,
  DARK_ORANGE_COLOR,
} from "../../constants/ColorConstants"
import {
  PHONE, PHONE_XS, TAB_LAND, TAB_PORT
} from "../../constants/BreakpointConstants"

export const StyledSection = styled.section`
color: ${WHITE_COLOR};
min-height: 100vh;
height: 100vh;
display: flex;
align-items: center;
border-bottom: 0px;
background: transparent;
font-weight: 400;
padding: 0rem 5.6rem;
margin-bottom: 0;
top: 0;
left: 0;
right: 0;
z-index: -1;

@media (max-width: ${PHONE}) {
  padding: 0rem 1.6rem;
}

.video {
  object-fit: cover;
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: -1;
  top: 0;
  left: 0;
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
  transform: scale(1.04);
}

.title {
  font-size: 5.6rem;
  font-weight: 700;
  margin-bottom: 3.2rem;
  text-align: left;
  -webkit-filter: drop-shadow(0.35rem 0.35rem 0.4rem rgba(0, 0, 0, 0.5));
  filter: drop-shadow(0.35rem 0.35rem 0.4rem rgba(0, 0, 0, 0.25));

  @media (max-width: ${TAB_LAND}) {
    font-size: 4rem;
  }

  @media (max-width: ${TAB_PORT}) {
    font-size: 3.6rem;
    text-align: center;
  }

  @media (max-width: ${PHONE}) {
    font-size: 3.5rem;
    line-height: 1.5;
  }

  @media (max-width: ${PHONE_XS}) {
    font-size: 2.8rem;
  }
}

.name {
  background-image: linear-gradient(
    135deg,
    ${DARK_ORANGE_COLOR} 0%,
    ${ORANGE_COLOR} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.cta {
  display: flex;

  @media (max-width: ${TAB_PORT}) {
    justify-content: center;
  }

  & a {
    font-size: 2.4rem;

    @media (max-width: ${PHONE}) {
      font-size: 2rem;
    }
  }
}
`
